import axios from 'axios'
import store from '@/store' // 导入创建好的store实例

const request = axios.create({
    timeout: 30000, //请求超时时间：30秒
    withCredentials: false, // 表示跨域请求时是否需要使用凭证
    headers: {
        Platform: 'PC',
    },
})

// 请求拦截器
request.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) config.headers['Authorization'] = `Bearer ${token}`
        //配置信息处理
        return config
    },
    error => {
        //错误处理
        return Promise.reject(error)
    }
)

// 响应拦截器
request.interceptors.response.use(
    res => {
        // 请求成功的回调函数
        if (res.data.code === 401) {
            // 未登录
            store.dispatch('logout')
        } else if (res.data.code === 403) {
        }
        return res
    },
    err => {
        // 请求失败的回调函数
        return Promise.reject('fail')
    }
)

export default request
